import { render, staticRenderFns } from "./IndustriesOptions.vue?vue&type=template&id=41107013&scoped=true"
import script from "./IndustriesOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndustriesOptions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IndustriesOptions.vue?vue&type=style&index=0&id=41107013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41107013",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSurveyQuestion: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/Question.vue').default,IxTreeselectIndustry: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/treeselect/Industry.vue').default})
